import { Serializable, CheckBoxProperty, TextProperty, BaseProperty, ServiceSelectorProperty, DataSourceType, ObjectListPropertyExt, TranslatableTextProperty } from "../property_types.js"
import { FlexcelExportSettings } from "../common_metadata/flexcel_export.js"

export class StatisticSettings extends Serializable {

    private disableLoadParamsFromStorageMetadata = new CheckBoxProperty("disableLoadParamsFromStorage", "Disable load parameter");
    public disableLoadParamsFromStorage: boolean;

    private loadDataOnStartMetadata = new CheckBoxProperty("loadDataOnStart", "Load data on start");
    public loadDataOnStart: boolean;

    private autorefreshIntervalMetadata = new TextProperty("autorefreshInterval", "Auto refresh interval in seconds");
    public autorefreshInterval: boolean;

    private startWithCollapsedParametersMetadata = new CheckBoxProperty("startWithCollapsedParameters", "Start with collapsed parameters");
    public startWithCollapsedParameters: boolean;

    private reloadOnChangeMetadata = new CheckBoxProperty("reloadOnChange", "Reload on parameters change");
    public reloadOnChange: boolean;

    private saveParametersForStatisticMetadata = new CheckBoxProperty("saveParametersForStatistic", "Don't share parameters with other statistics");
    public saveParametersForStatistic: boolean;

    private fullHeightMetadata = new CheckBoxProperty("fullHeight", "Use full height for rows");
    public fullHeight: boolean;

    private exportMetadata = new ObjectListPropertyExt("exports", "Exports")
        .addStateImplementation("flexcel", FlexcelExportSettings);

    private exports: FlexcelExportSettings;

    private statisticSettingsMetadata: BaseProperty[] = [this.disableLoadParamsFromStorageMetadata, this.saveParametersForStatisticMetadata,
    this.loadDataOnStartMetadata, this.autorefreshIntervalMetadata, this.startWithCollapsedParametersMetadata,
    this.reloadOnChangeMetadata, this.exportMetadata,
    this.fullHeightMetadata];

    getMetadata(): BaseProperty[] {
        return this.statisticSettingsMetadata;
    }
}